var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ed-table',{key:_vm.$root.$session.versao,attrs:{"strModel":"Agendamento/Agendamento","headers":_vm.arrayHeaders,"rows":_vm.arrayRows,"pagination":_vm.objResult,"filter":_vm.formData,"loading":_vm.loading,"config":{
      registerName: 'Adicionar Agendamento',
      searchName: 'Pesquisar pelo nome ou CPF do funcionário',
    }},on:{"register":_vm.onRegister,"edit":_vm.onEdit,"search":_vm.getAgendamento}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }